
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/addresses/new",
      function () {
        return require("private-next-pages/mypage/addresses/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/addresses/new"])
      });
    }
  